import * as React from 'react';

interface DataPoint {
  label: () => React.ReactNode;
  value: number;
}

interface Props {
  data: DataPoint[];
  barColorClass?: string;
}

const VoteBar = ({
  width,
  barColorClass = 'bg-amber-500',
}: {
  width: number;
  barColorClass?: string;
}) => {
  return (
    <div className="rounded-full bg-grey-100 h-2 w-full">
      <div
        style={{ width: `${width}%` }}
        className={`rounded-full h-full ${barColorClass}`}
      />
    </div>
  );
};

export const HorizontalBarChart = ({ data, barColorClass }: Props) => {
  const maxScore = data.reduce((max, { value }) => Math.max(value, max), 0);

  return (
    <div className="space-y-4">
      {data.map(({ label, value }, idx) => {
        const barWidth = (value / maxScore) * 100;

        return (
          <div className="flex items-center" key={`${idx}-${value}`}>
            <div className="w-1/2 sm:w-1/3 min-w-32 pr-4">{label()}</div>
            <div className="flex-grow flex items-center">
              <VoteBar width={barWidth} barColorClass={barColorClass}></VoteBar>
            </div>
            <div className="pl-6 md:pl-8 text-grey-400">{value}</div>
          </div>
        );
      })}
    </div>
  );
};
